import ExcelJS from "exceljs";
import AlertManager from "../Alert/Alert";

export const exportRowsToXlsx = ({
  columns = [],
  rows = [],
  fileName = "export.xlsx",
  sheetName = "Sheet1",
  warningMessage = "No data to export.",
}) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    AlertManager.warning(warningMessage, { contactSupport: false });
    return;
  }

  const { headerRow, dataRows } = buildExportTable({ columns, rows });

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(sheetName);
  worksheet.addRow(headerRow);
  dataRows.forEach((row) => worksheet.addRow(row));

  workbook.xlsx
    .writeBuffer()
    .then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const urlFactory = globalThis.URL;
      const url = urlFactory.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      urlFactory.revokeObjectURL(url);
    })
    .catch((err) => {
      // Surface a friendly error if export fails (e.g., browser limitations).
      // eslint-disable-next-line no-console
      console.error("Excel export failed", err);
      AlertManager.error("Unable to export file. Please try again.", { contactSupport: false });
  });
};

export const buildExportTable = ({ columns = [], rows = [] } = {}) => {
  const exportableColumns = columns.filter((col) => col.field && col.headerName && !col.hideFromExport);
  const headerRow = exportableColumns.map((col) => col.headerName);
  const dataRows = rows.map((row) =>
    exportableColumns.map((col) => {
      let value = row[col.field];

      if (typeof col.valueGetter === "function") {
        try {
          const computedValue = col.valueGetter({ value, row, field: col.field });
          if (computedValue !== undefined && computedValue !== null) {
            value = computedValue;
          }
        } catch (err) {
          // Swallow getter errors and continue with the raw value.
        }
      }

      if (typeof col.valueFormatter === "function") {
        try {
          const formatted = col.valueFormatter({ value, row, field: col.field });
          if (formatted !== undefined && formatted !== null) {
            return formatted;
          }
        } catch (err) {
          // Swallow formatter errors and fall back to raw values for export.
        }
      }

      if (value === undefined || value === null) return "";
      return typeof value === "string" ? value : String(value);
    })
  );

  return { exportableColumns, headerRow, dataRows };
};

export default exportRowsToXlsx;
